import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'option',
    standalone: false
})
export class OptionPipe implements PipeTransform {

  transform(values: Partial<any>[] | null, ...args: string[]): {
    key: string;
    value: string;
  }[] {
    if (values === null) {
      return [];
    }

    return values.map((it: Partial<any>) => ({
      key: it[args[0] ?? 'key'],
      value: it[args[1] ?? 'value']
    }));
  }

}
